(function() {

    var popup_upsell = document.querySelector(".popup-upsell");
    var scrollPosition = 0;
    document.querySelectorAll('.popup-upsell .popup__close').forEach(function(button) {
        button.addEventListener('click', function() {
            popup_upsell.classList.remove("visible");

            /*
              document.body.removeAttribute('style');
              window.pageYOffset = scrollPosition;
              */
        });
    });

    var add_to_cart = document.querySelector(".add-to-cart__button");
    add_to_cart.addEventListener('click', function() {
        setTimeout(() => {
            popup_upsell.classList.add("visible");

            /*
              scrollPosition = window.pageYOffset;
              document.body.style.setProperty('overflow', 'hidden');   
              document.body.style.setProperty('position', 'fixed');  
              document.body.style.setProperty('top', `-${scrollPosition}px`);  
              document.body.style.setProperty('width', '100%');
              */
        }, 500);
    });
    document.addEventListener("dblclick", function(e) {
        if (popup_upsell.classList.contains('visible')) {
            e.preventDefault();
        }
    }, {
        passive: false
    });

    /*
    function noScrollupsellPopup(event) {
    var popup_upsell = document.querySelector(".popup-upsell");
    if( popup_upsell.classList.contains("visible") ){
      event.preventDefault();
    }
    }

    document.addEventListener('touchmove', noScrollupsellPopup, { passive: false });
    document.addEventListener('mousewheel', noScrollupsellPopup, { passive: false });
    */
})();
